/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-10-11 10:11:20
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-12 16:41:15
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 发票管理分页列表
export const listByPage = params =>
  request(BASE_URL + '/govUploadInvoice/listByPage', { params })
// 获取年份列表
export const getDataYear = params =>
  request.get(BASE_URL + '/govUploadInvoice/getDataYear', { params })
// 发票管理-详情
export const getGovUploadInvoiceDetail = params =>
  request.get(BASE_URL + '/govUploadInvoice/getGovUploadInvoiceDetail', {
    params
  })
// 发票管理-审核
export const auditStatus = data =>
  request.post(BASE_URL + '/govUploadInvoice/auditStatus', data)
// 发票管理-日志列表
export const getGovInvoiceRecordList = params =>
  request.get(BASE_URL + '/govUploadInvoice/getGovInvoiceRecordList', {
    params
  })
// 企业状态
export const getInvoiceStatus = params =>
  request.get(BASE_URL + '/entUploadInvoice/getInvoiceStatus', {
    params
  })
// 日志列表-机构端
export const getInvoiceRecordList = params =>
  request.get(BASE_URL + '/entUploadInvoice/getInvoiceRecordList', {
    params
  })
// 机构上传发票详情
export const getEntUploadInvoiceDetail = params =>
  request.get(BASE_URL + '/entUploadInvoice/getEntUploadInvoiceDetail', {
    params
  })
// 机构上传发票详情
export const submitAudit = data =>
  request.post(BASE_URL + '/entUploadInvoice/submitAudit', data)
